export const INCLUDED_LISTINGS_TYPES = ['search', 'category'];
export const INCLUDED_LEAF_IDS = [
    140, 141, 364, 514, 520, 1070, 1071, 1072, 1073, 1074, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2243, 2244,
    2245, 2246, 2247, 2248, 2306, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2616, 2617, 2618, 2630, 2631, 2632, 2633,
    2634, 2635, 2668, 2669, 2670, 2671, 2672, 2673, 2703, 2704, 2714, 2715, 2736, 2740, 2741, 2758, 2759, 2760, 2761,
    2762, 2763, 2764, 2792, 2793, 2802, 2803, 2814, 2936, 2937, 2956, 2958, 2973, 2980,
];
